<template>
  <!-- 如果需要上传视频和预览图时，需要添加画布显示设置 -->
  <!-- <AttrGroup v-if="androidWatcfaceOS == 'android' && isVideo" title="画布显示">
    <AttrSwitch
      label="视频"
      :value="(shape.attrs.videoTypeToShow ?? 'video') == 'video'"
      :disabled="!!attrDisabled"
      @change="changeVideoToShow"
    />
    <AttrSwitch
      class="mt-2.5"
      label="预览图"
      :value="shape.attrs.videoTypeToShow == 'image'"
      :disabled="!!attrDisabled"
      @change="changeVideoToShow"
    />
  </AttrGroup> -->

  <!-- 如果是多个资源 -->
  <AttrGroup
    v-if="spriteItems.length > 1"
    title="默认显示"
    tooltip="设置默认显示的视频或序列帧"
  >
    <AttrSwitch
      v-for="(spriteItem, index) in spriteItems"
      :key="spriteItem.id"
      :class="{
        'mt-2.5': index > 0
      }"
      :label="
        (isVideo
          ? androidWatcfaceOS == 'vela'
            ? '预览图'
            : '视频'
          : '序列帧') +
        (index + 1)
      "
      :value="(shape.attrs.extraIdToPlay ?? '') == spriteItem.id"
      :disabled="!!attrDisabled"
      @change="(checked:boolean) => changeItemToShow(spriteItem,checked)"
    />
  </AttrGroup>
</template>

<script lang="ts" setup>
import { useWatchfaceAndroid } from '@/hooks';
import { Shape } from '@/services/shape';
import { SpriteAttribute } from '@/services/shape/attributes/sprite';
import { useEditorStore } from '@/store/use-editor-store';
import { computed } from 'vue';
import { PropType } from 'vue';

const props = defineProps({
  shape: {
    type: Object as PropType<Shape>,
    required: true
  },
  isSprite: {
    type: Boolean,
    required: true
  },
  isVideo: {
    type: Boolean,
    required: true
  },
  spriteItems: {
    type: Array as PropType<SpriteAttribute['spriteExtra']>,
    default: () => []
  }
});

const editorStore = useEditorStore();
const attrDisabled = computed(() => editorStore.attrDisabled);
const { androidWatcfaceOS } = useWatchfaceAndroid();

const changeVideoToShow = () => {
  const shape = props.shape;
  const type =
    (shape.attrs.videoTypeToShow ?? 'video') == 'image' ? 'video' : 'image';
  shape.setAttrs({
    videoTypeToShow: type
  });
};
const changeItemToShow = (
  item: SpriteAttribute['spriteExtra'][0],
  checked: boolean
) => {
  const id = checked
    ? item.id
    : props.spriteItems.filter((i) => i.id != item.id)[0].id;

  const shape = props.shape;
  shape.setAttrs({
    extraIdToPlay: id
  });
};
</script>
